import { ACCENT_COLORS } from './consts';
import { AccentColor } from './types';

export const toAccentColor = <T extends string>(color?: T): AccentColor => {
  return ACCENT_COLORS.find((accent) => `${color}` === accent) ?? 'surrogate';
};
